import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router";
import Actions from "../Redux/action";
import { toast } from "react-toastify";
import moment from "moment";
import nodatafound from '../asset/img/datanotfound_black.png';
import AppLoader from "../component/AppLoader";
import { getHostelListSelectSelector } from "../Redux/reducer/HostelReducer";
import ExcelJS from "exceljs";
import * as FileSaver from "file-saver";

const EXCEL_EXTENSION = '.xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

export const StudentDayWiseReport = () => {
    const { hostelId, date } = useParams();
    const dispatch = useDispatch();
    const hostelList = useSelector(getHostelListSelectSelector);
    const [viewReports, setViewReport] = useState(true);
    const [isLoading, setLoading] = useState(false);
    const [params, setParams] = useState();
    const navigate = useNavigate();
    const location = useLocation();
    const { fromDate, toDate, formDetails, hostelName: stateHostelName, response } = location.state || {};  // Use default empty object in case state is not passed


    // useEffect(() => {
    //     const callback = (response) => {
    //         if (response?.status_code === 0) {
    //             setParams(response?.response);
    //             setViewReport(response?.response?.data);
    //             setLoading(false);
    //         } else {
    //             toast.error(response?.message);
    //             setLoading(false);
    //         }
    //     };

    //     const params = {
    //         hostel_id: hostelId,
    //         date: date
    //     };

    //     setLoading(true);
    //     dispatch(Actions.daywiseReportAction(params, callback));
    // }, [dispatch, hostelId, date]);

    const handleBack = () => {
        navigate('/studentReport', {
            state: location.state
        });
    };

    const displayHostelName = stateHostelName || hostelList?.find((h) => h?.id == formDetails?.hostel_id)?.name || "Hostel";
    const displayDate = fromDate ? (moment(fromDate).isValid() ? moment(fromDate).format("DD-MM-YYYY") : String(fromDate)) : "-";
    const displayTime = formDetails?.start_time && formDetails?.end_time
        ? `${String(formDetails.start_time).slice(0, 5)} - ${String(formDetails.end_time).slice(0, 5)}`
        : "-";

    const filterColumns = (rows, allowed) => {
        return rows.map(row => {
            const filtered = {};
            allowed.forEach(col => {
                if (row[col] !== undefined) filtered[col] = row[col];
            });
            return filtered;
        });
    };



    const exportAsExcelFile = async (json, excelFileName) => {
        const presenteeColumns = [
            { key: "name", header: "Name" },
            { key: "member_id", header: "Member ID" },
            { key: "date", header: "Date" },
            { key: "time", header: "Time" },
            { key: "attendance_type", header: "attendance_type" },
        ];
        const absenteeColumns = [
            { key: "name", header: "Name" },
            { key: "member_id", header: "Member ID" },
            { key: "last_activity_time", header: "last_activity_time" },
        ];

        const mapCameraType = (data) => {
            return data.map(item => ({
                ...item,
                camera_type: item.entry === "EN" ? "Entry" :
                    item.entry === "EX" ? "Exit" : item.entry
            }));
        };

        const mapRows = (rows, columns) =>
            rows.map((row) => {
                const mapped = {};
                columns.forEach(({ key, header }) => {
                    mapped[header] = row[key] ?? "";
                });
                return mapped;
            });

        let presentees = mapCameraType(json?.response || []);
        let absentees = mapCameraType(json?.absentees || []);

        presentees = mapRows(
            filterColumns(presentees, presenteeColumns.map((c) => c.key)),
            presenteeColumns
        );
        absentees = mapRows(
            filterColumns(absentees, absenteeColumns.map((c) => c.key)),
            absenteeColumns
        );

        const hostelName = displayHostelName;
        const dateTimeText = `Date: ${displayDate} | Time: ${displayTime}`;

        const addSheetWithHeaders = (workbook, sheetName, rows, columns) => {
            const sheet = workbook.addWorksheet(sheetName);
            const headers = columns.map((c) => c.header);
            const colCount = Math.max(headers.length, 1);
            sheet.mergeCells(1, 1, 1, colCount);
            const cell1 = sheet.getCell(1, 1);
            cell1.value = hostelName;
            cell1.font = { bold: true };
            cell1.alignment = { horizontal: "center", vertical: "middle" };

            sheet.mergeCells(2, 1, 2, colCount);
            const cell2 = sheet.getCell(2, 1);
            cell2.value = dateTimeText;
            cell2.font = { bold: true };
            cell2.alignment = { horizontal: "center", vertical: "middle" };

            const headerRow = sheet.getRow(3);
            headers.forEach((header, i) => {
                const cell = headerRow.getCell(i + 1);
                cell.value = header;
                cell.font = { bold: true };
            });

            rows.forEach((row, rIdx) => {
                const rowNum = 4 + rIdx;
                const r = sheet.getRow(rowNum);
                headers.forEach((header, cIdx) => {
                    r.getCell(cIdx + 1).value = row[header] ?? "";
                });
            });

            headers.forEach((header, i) => {
                let maxLen = header.length;
                rows.forEach((row) => {
                    const len = String(row[header] ?? "").length;
                    maxLen = Math.max(maxLen, len);
                });
                sheet.getColumn(i + 1).width = Math.min(maxLen + 2, 50);
            });
        };

        const workbook = new ExcelJS.Workbook();
        addSheetWithHeaders(workbook, "Presentees", presentees, presenteeColumns);
        addSheetWithHeaders(workbook, "Absentees", absentees, absenteeColumns);

        const buffer = await workbook.xlsx.writeBuffer();
        saveAsExcelFile(buffer, excelFileName);
    };

    const saveAsExcelFile = (buffer, fileName) => {
        const data = new Blob([buffer], { type: EXCEL_TYPE });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }
    const handleReportDownload = () => {
        exportAsExcelFile(response, "Reports");
    };
    return (
        <>
            {isLoading && <AppLoader />}
            <div className="ecommerce-widget">
                <h5 className="card-header">Day-wise Report</h5>
                <div className="card mb-3 mt-3 p-3 bg-light rounded">
                    <h6 className="mb-2 fw-bold">Selected filter</h6>
                    <div className="d-flex flex-wrap gap-3 small">
                        <span><strong>Hostel:</strong> {displayHostelName}</span>
                        <span><strong>Date:</strong> {displayDate}</span>
                        <span><strong>Time:</strong> {displayTime}</span>
                    </div>
                </div>
                <div className="mb-2 mt-3" style={{ textAlign: 'end' }}>
                    <button type="button" className="btn btn-primary ml-3" onClick={() => handleReportDownload()}>Download Report</button>
                    &nbsp;
                    <button type="button" className="btn btn-primary" onClick={handleBack}>Back</button>
                </div>
                <h5 className="card-day-wise-heading">Report for {params?.hostel} On {params?.date}</h5>
                <div className="row mt-4 row-day-wise-report">
                    <div className="col-md-6 col-sm-6 mb-3">
                        <div className="card card-hostel-dashboard border-3 border-top border-top-primary h-100">
                            <div className="card-body dashboardCards text-center">
                                <h4 className="text-muted bold card-text-muted">Total People In</h4>
                                <h5 className="text-muted">
                                    {response?.total_present ?? 0}
                                </h5>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-sm-6 mb-3">
                        <div className="card card-hostel-dashboard border-3 border-top border-top-primary h-100">
                            <div className="card-body dashboardCards text-center">
                                <h4 className="text-muted bold card-text-muted">Total People Out</h4>
                                <h5 className="text-muted">
                                    {response?.total_absentees ?? 0}
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>

                {viewReports && (
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="table-responsive table-container">
                                        <table className="table onboardTable">
                                            <thead className="bg-light">
                                                <tr className="border-0">
                                                    <th className="border-0">Present Students</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {response?.response?.map((i) => (
                                                    <tr key={i.member_id}>
                                                        <td>{i.name} ({i.member_id})</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="table-responsive table-container">
                                        <table className="table onboardTable">
                                            <thead className="bg-light">
                                                <tr className="border-0">
                                                    <th className="border-0">Absent Students</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {response?.absentees?.map((person) => (
                                                    <tr key={person.member_id}>
                                                        <td>{person.name} ({person.member_id})</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            {(!viewReports) && (
                                <div className="d-flex justify-content-center mt-5">
                                    <div className="NodataFound mb-3">
                                        <h3>No Data Found</h3>
                                    </div>
                                    <div className="NodataImage">
                                        <img src={nodatafound} alt="No Data Found" className="NoData" />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};
